import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const walletTransactionSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  type: z.enum(["BONUS", "REWARD", "WITHDRAWAL", "MANUAL"]),
  amount: z.number(),
  balanceBefore: z.number(),
  balanceAfter: z.number(),
  reference: z.string().optional().nullable(),
  paymentId: z.string().optional().nullable(),
  withdrawalId: z.string().optional().nullable(),
  createdAt: z.coerce.date(),
});

export class WalletTransactionDto extends createZodDto(walletTransactionSchema) {}
